"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MiniChart = exports.LineChart = exports.LineChartRef = exports.GradientDefinition = exports.ChartRenderer = void 0;
var react_1 = __importStar(require("react"));
var react_dom_1 = require("react-dom");
var Chart_1 = require("./Chart");
var ChartTooltip_1 = require("./ChartTooltip");
var layout_utils_1 = require("./layout-utils");
var Legend_1 = require("./Legend");
var LineRenderer_1 = require("./LineRenderer");
var Normalizer_1 = require("./Normalizer");
var scales_1 = require("./scales");
function updateNormalizers(chart) {
    var xNormalizer = new Normalizer_1.Normalizer("x", chart.width);
    chart.data.forEach(function (s) { return xNormalizer.updateData(s.data); });
    if (xNormalizer.isSpot)
        xNormalizer.updateData([{ x: xNormalizer.min - 10 }, { x: xNormalizer.max + 10 }]);
    xNormalizer.saveMinMax();
    if (chart.data.filter(function (s) { return s.type == 'bar'; }).length > 0) {
        var layout = (0, LineRenderer_1.createBarOffset)(chart.data, chart.width);
        var x1 = xNormalizer.toDataScale(layout.offsetBase);
        var x2 = xNormalizer.toDataScale(0);
        var diff = Math.abs(x1 - x2) * 1.5;
        xNormalizer.updateData([{ x: xNormalizer.min - diff }, { x: xNormalizer.max + diff }]);
    }
    if (chart.data.filter(function (s) { return s.type == 'simple-bar'; }).length > 0) {
        var layout = (0, LineRenderer_1.createSimpleBarOffset)(chart.data, chart.width);
        var x1 = xNormalizer.toDataScale(layout.offsetBase);
        var x2 = xNormalizer.toDataScale(0);
        var diff = Math.abs(x1 - x2) * 1.5;
        xNormalizer.updateData([{ x: xNormalizer.min - diff }, { x: xNormalizer.max + diff }]);
    }
    else
        xNormalizer.updateData([{ x: xNormalizer.min - (xNormalizer.range * .05) }, { x: xNormalizer.max + (xNormalizer.range * .05) }]);
    return __assign(__assign({}, chart), { xNormalizer: xNormalizer });
}
function toggleHidden(chart, serie) {
    if (!chart.hidden)
        return __assign(__assign({}, chart), { hidden: [serie], highLightSpots: null });
    var newHidden;
    if (chart.hidden.includes(serie))
        newHidden = chart.hidden.filter(function (c) { return c != serie; });
    else
        newHidden = __spreadArray(__spreadArray([], chart.hidden, true), [serie], false);
    return __assign(__assign({}, chart), { hidden: newHidden, highLightSpots: null });
}
function reducer(chart, action) {
    switch (action.type) {
        case "setWidth": return updateNormalizers(__assign(__assign({}, chart), { width: action.payLoad }));
        case "setHighLight": return __assign(__assign({}, chart), { highLightSpots: action.payLoad });
        case "toggleHidden": return toggleHidden(chart, action.payLoad);
        case "setHidden": return __assign(__assign({}, chart), { hidden: action.payLoad, highLightSpots: null });
        case "replaceAll": return __assign(__assign({}, chart), action.payLoad);
    }
}
function computeLeft(div) {
    var n = 0;
    var c = div.offsetParent;
    while (c != null) {
        n += c.offsetLeft;
        c = c.offsetParent;
    }
    return n;
}
function ChartRenderer() {
    var _a;
    var windowWidth = (0, layout_utils_1.useWindowWidth)();
    var divRef = (0, react_1.useRef)(null);
    var chart = (0, react_1.useContext)(Chart_1.ChartContext);
    var height = chart.height, dispatch = chart.dispatch, width = chart.width, data = chart.data, hidden = chart.hidden;
    var _b = (0, react_1.useState)(null), tooltipContent = _b[0], setTooltipContent = _b[1];
    var isHidden = (0, Chart_1.useIsSerieHidden)();
    var visible = (0, react_1.useMemo)(function () {
        return data.filter(function (c) { return !isHidden(c.label); });
    }, [hidden, data]);
    (0, react_1.useLayoutEffect)(function () {
        var w = divRef.current.offsetWidth;
        if (w < chart.minWidth)
            w = chart.minWidth;
        dispatch({ type: "setWidth", payLoad: w });
    }, [windowWidth]);
    function onMouseMove(e) {
        if (!width)
            return;
        var left = chart.tooltipContainer ? document.querySelector(chart.tooltipContainer).offsetLeft : computeLeft(divRef.current);
        var localX = e.clientX - (divRef.current.offsetLeft + left) + divRef.current.scrollLeft;
        var x = chart.xNormalizer.toDataScale(localX);
        var translator = chart.groupTooltipItems ? Chart_1.defaultPointTranslator : (0, LineRenderer_1.transformBarX)(chart);
        dispatch({ type: 'setHighLight', payLoad: (0, Chart_1.getNearestItems)(visible, x, translator) });
    }
    function onTouchMove(e) {
        if (!width)
            return;
        var localX = e.touches[0].clientX - divRef.current.offsetLeft + divRef.current.scrollLeft;
        var x = chart.xNormalizer.toDataScale(localX);
        var translator = chart.groupTooltipItems ? Chart_1.defaultPointTranslator : (0, LineRenderer_1.transformBarX)(chart);
        var spots = (0, Chart_1.getNearestItems)(visible, x, translator);
        dispatch({ type: 'setHighLight', payLoad: spots });
    }
    function removeTooltip() {
        dispatch({ type: 'setHighLight', payLoad: null });
        setTooltipContent(null);
    }
    function mouseLeave(e) {
        if (!width)
            return;
        if (e.currentTarget != e.target)
            return;
        removeTooltip();
    }
    var spot = chart.highLightSpots && chart.highLightSpots.length ? chart.highLightSpots[0].item.x : null;
    (0, react_1.useEffect)(function () {
        if (spot !== null && chart.createTooltip) {
            setTooltipContent(chart.createTooltip(chart.highLightSpots));
            divRef.current.focus();
        }
        else
            setTooltipContent(null);
    }, [spot]);
    var props = width == chart.minWidth ? { width: width + "px" } : {};
    var tooltipContainer = chart.tooltipContainer ? ((_a = document.querySelector(chart.tooltipContainer)) !== null && _a !== void 0 ? _a : document.body) : document.body;
    return react_1.default.createElement("div", { className: 'chart-svg', onBlur: removeTooltip, tabIndex: -1, ref: divRef, style: { outline: "none", overflowX: "auto", overflowY: "hidden", width: chart.hideXScale ? "auto" : "150px" } },
        react_1.default.createElement("svg", { style: __assign({ height: height + "px" }, props), onMouseMove: onMouseMove, onTouchStart: onTouchMove, onTouchMove: onTouchMove, onMouseLeave: mouseLeave },
            data.map(function (_a) {
                var style = _a.style;
                return react_1.default.createElement(GradientDefinition, { key: style, style: style });
            }),
            width && height > 70 && react_1.default.createElement(scales_1.LineChartBgScale, null),
            width && react_1.default.createElement(LineRenderer_1.LineRenderer1, null),
            width && height >= 100 && react_1.default.createElement(LineRenderer_1.HighLightSpots, null)),
        width && !chart.hideXScale && react_1.default.createElement(scales_1.ChartXScale, { style: __assign({}, props), chart: chart }),
        (0, react_dom_1.createPortal)(react_1.default.createElement(ChartTooltip_1.ChartTooltip, { content: tooltipContent, reference: divRef }), tooltipContainer));
}
exports.ChartRenderer = ChartRenderer;
function buildChart(options, hideXScale) {
    var _a;
    if (hideXScale === void 0) { hideXScale = false; }
    var yNormalizer = new Normalizer_1.Normalizer("y", options.height);
    yNormalizer.invert = true;
    options.data.forEach(function (s) { return yNormalizer.updateData(s.data); });
    if (yNormalizer.isSpot)
        yNormalizer.updateData([{ y: yNormalizer.min - 10 }, { y: yNormalizer.min + 10 }]);
    if (options.hintScales)
        yNormalizer.updateData(options.hintScales.map(function (s) { return ({ y: s.value }); }));
    yNormalizer.saveMinMax();
    var newLower = yNormalizer.min - (yNormalizer.range * .1);
    if (options.marginBottom === 0) {
        if (newLower < 0 && yNormalizer.dataMin >= 0)
            newLower = 0;
    }
    if (options.yDataMinZero) {
        newLower = 0;
    }
    yNormalizer.updateData([{ y: newLower }, { y: yNormalizer.max + (yNormalizer.range * .1) }]);
    var minWidth = (_a = options.minWidth) !== null && _a !== void 0 ? _a : 150;
    return __assign(__assign({}, options), { minWidth: minWidth, yNormalizer: yNormalizer, hideXScale: hideXScale });
}
function GradientDefinition(_a) {
    var style = _a.style;
    return react_1.default.createElement("linearGradient", { id: "grad-".concat(style), x1: "0%", y1: "0%", x2: "0%", y2: "100%" },
        react_1.default.createElement("stop", { offset: "0%", className: 'main-color' }),
        react_1.default.createElement("stop", { offset: "100%", className: 'end-color' }));
}
exports.GradientDefinition = GradientDefinition;
function LineChartRef(options, ref) {
    var _a = (0, react_1.useReducer)(reducer, buildChart(options)), chart = _a[0], dispatch = _a[1];
    (0, react_1.useImperativeHandle)(ref, function () {
        return { dispatch: dispatch };
    });
    return react_1.default.createElement(Chart_1.ChartContext.Provider, { value: __assign(__assign({}, chart), { dispatch: dispatch }) },
        react_1.default.createElement("div", { className: "simple-svg-chart chart" },
            react_1.default.createElement(scales_1.ChartYScale, { chart: chart }),
            react_1.default.createElement(ChartRenderer, null),
            !chart.hideLegend && react_1.default.createElement(Legend_1.Legend, null)));
}
exports.LineChartRef = LineChartRef;
exports.LineChart = (0, react_1.forwardRef)(LineChartRef);
function MiniChart(options) {
    var _a = (0, react_1.useReducer)(reducer, buildChart(options, true)), chart = _a[0], dispatch = _a[1];
    /*useEffect(() => {
        dispatch({type: "replaceAll", payLoad: buildChart(options, true)})
    }, [options.data]);*/
    return react_1.default.createElement(Chart_1.ChartContext.Provider, { value: __assign(__assign({}, chart), { dispatch: dispatch }) },
        react_1.default.createElement("div", { className: "simple-svg-chart chart" },
            react_1.default.createElement(ChartRenderer, null)));
}
exports.MiniChart = MiniChart;
//# sourceMappingURL=LineChart.js.map